export default __webpack_public_path__ + "static/qt-sweetcombe-marque-4-star-silver-rgb-4a3d37dd9afe5a4fb83ce9b981bfa5ec.png";